<script>
import Layout from '@layouts/main';
import JobForm from '@views/jobs/form';

export default {
  components: {
    Layout,
    JobForm,
  },
  page() {
    return {
      title: this.$t('titles.create_job'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.jobs'),
          to: { name: 'jobs.index' },
        },
        {
          text: this.$t('titles.create_job'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create(job) {
      this.$router.push({
        name: 'jobs.edit',
        params: {
          id: job.id,
        },
        query: {
          create: 1,
        },
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <JobForm @submitted="create" />
  </Layout>
</template>
